import { Image } from 'react-native';

type Size = {
  width: number;
  height: number;
};

export const getImageSize = async (uri: string): Promise<Size> =>
  new Promise<Size>((resolve, reject) => {
    Image.getSize(uri, (width, height) => resolve({ width, height }), reject);
  });
